import { PhaseProtocolSDK } from "@dedmonkes/phase-protocol-sdk";
import { useContext } from "react";
import { PhaseSDKContext } from "../context/PhaseSDKProvider";

const usePhaseSdk = (): PhaseProtocolSDK => {
    return useContext(PhaseSDKContext);
};

export default usePhaseSdk;
